<template>
  <div class="radio-list-2">
    <label v-for="{ key, checked, disabled, label } in list" :key="key">
      <input type="radio" :checked="checked" :disabled="disabled" @change="change(key)" />
      <span>{{ label }}</span>
    </label>
  </div>
</template>

<script>
/**
 * ラジオリスト
 */
export default {
  name: 'RadioList',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /** 値 (v-model) BooleanはitemsがMapの時のみ */
    value: { type: [Number, String, Boolean], default: null },
    /** 選択肢 */
    items: [Object, Map, Array],
    /** 非活性にする選択肢のキー */
    disabledKeys: { type: [Number, String, Boolean, Array], default: null },
  },
  computed: {
    list() {
      const disabledKeys = [].concat(this.disabledKeys)
      if (this.items instanceof Map) {
        return Array.from(this.items).map(([key, value]) => ({
          key,
          checked: this.value === key,
          disabled: disabledKeys.includes(key),
          label: value,
        }))
      }
      if (this.items instanceof Array) {
        return this.items.map((value, index) => ({
          key: index,
          checked: this.value === index,
          disabled: disabledKeys.includes(index),
          label: value,
        }))
      }
      let keys = Object.keys(this.items)
      if (typeof this.value === 'number') {
        keys = keys.map(k => +k)
      }
      return keys.map(key => ({
        key,
        checked: this.value === key,
        disabled: disabledKeys.includes(key),
        label: this.items[key],
      }))
    },
  },
  methods: {
    change(key) {
      /**
       * 選択値 (v-model)
       * @event change
       * @type {String|Number|Boolean}
       */
      this.$emit('change', key)
    },
  },
}
</script>

<style lang="postcss" scoped>
.radio-list-2 {
  border: 1px solid var(--border-color);
  border-radius: 4px;
  display: grid;
  font-size: 15px;
  grid-auto-columns: 103px;
  grid-auto-flow: column;
  height: 40px;
  overflow: hidden;
  width: min-content;

  label {
    box-sizing: border-box;

    &:not(:first-child) {
      border-left: 1px solid var(--border-color);
    }

    span {
      align-items: center;
      background-color: var(--white);
      cursor: pointer;
      display: flex;
      height: 100%;
      justify-content: center;
    }

    input[type='radio'] {
      display: none;

      &:checked + span {
        background-color: var(--very-light-yellow);
        font-weight: bold;
      }

      &:disabled + span {
        background-color: var(--light-gray);
        color: var(--very-light-gray);
        cursor: default;
      }
    }
  }
}
</style>
